@if(isDesktop && categoryGroup.childIds.length > categoryGroup.childs.length && !categoryGroup.headerFooterViewConfig.header.isShow) {
<div class="d-flex justify-content-end">
  <span [ngStyle]="getTitleStyle(categoryGroup.headerFooterViewConfig.header.title)" class="cursor-pointer" (click)="viewAll(categoryGroup)">{{
    "button-title.view-all" | translate
  }}</span>
</div>
}
<div class="d-flex flex-column" [ngStyle]="getProductContainerStyle(categoryGroup)">
  <div
    [ngClass]="{ 'grid-container': !isCart, 'horizontal-layout': !isCart && isHorizontalLayout(categoryGroup), 'vertical-layout': !isCart && !isHorizontalLayout(categoryGroup) }"
    [ngStyle]="getProductGridLayoutStyle(categoryGroup)"
  >
    @for (child of categoryGroup.childs; track child._id) {
    <app-product [product]="child" [categoryGroup]="categoryGroup" [merchantId]="merchantId" [serviceMainCategory]="serviceMainCategory" [isBrandType]="isBrandType" [serviceMerchantId]="serviceMerchantId"></app-product>
    }
  </div>
  @if(!isDesktop && categoryGroup.childIds.length > categoryGroup.childs.length && !categoryGroup.headerFooterViewConfig.header.isShow) {
  <div
    class="w-100 d-flex justify-content-center mt-3 p-1 rounded mt-1 cursor-pointer"
    [ngStyle]="getButtonStyle(categoryGroup.gridChildViewConfig)"
    (click)="viewAll(categoryGroup)"
  >
    <span class="fs-6" [ngClass]="categoryGroup && categoryGroup.gridChildViewConfig.button ? '' : 'text-white'">{{ "button-title.view-all" | translate }}</span>
  </div>
  }
</div>
